import { render, staticRenderFns } from "./ProfessionalsDiagramStep.vue?vue&type=template&id=756d39fc&scoped=true&"
import script from "./ProfessionalsDiagramStep.vue?vue&type=script&lang=js&"
export * from "./ProfessionalsDiagramStep.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalsDiagramStep.vue?vue&type=style&index=0&id=756d39fc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d39fc",
  null
  
)

export default component.exports